import React, { useRef, useState, useEffect } from 'react';
import { useParams } from "react-router";
import { Skeleton, Empty, Button, message, Modal, List } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { IMAGES, UPLOADS, FILES } from '../../../../params';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import 'swiper/swiper.min.css';
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
import { TbReload } from "react-icons/tb";
SwiperCore.use([Autoplay, Navigation, Pagination]);

export const Item = props => {
    
    const dispatch = useDispatch();
    const app_global = useSelector(state => state.app_global);
    
    const navigationPrevRef = React.useRef(null)
    const navigationNextRef = React.useRef(null)

    const [activeModal, setActiveModal] = useState("");

    const [page, setPage] = useState(1);
    const [page2, setPage2] = useState(1);
    const [paginationSize, setPaginationSize] = useState(6);

    const params = useParams();

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    async function component_start() {
        
    }

    return (
        <>
            {
                app_global.loading ?
                <section className='container shadow default_padding marginTop'>
                    <div className='content'>
                        <Skeleton active />
                    </div>
                </section>
            :
                <>
                    <Modal mask centered className="modal_portal" key="m1" width={1600} title="Как правильно питаться?" open={activeModal === 'snack'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                        <div className='header'>
                            <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                            </svg>
                            <h2>Как правильно питаться?</h2>
                        </div>
                        <div className='text_content'>
                            <h3>Почему вода важна для здоровья?</h3>
                        </div>
                        <div className='list_ul ol'>
                            <List itemLayout="vertical"
                                size="large"
                                pagination={{
                                    pageSize: 10,
                                    hideOnSinglePage: true,
                                    showSizeChanger: false,
                                    onChange(current, pageSize) {
                                        setPage2(current);
                                        setPaginationSize(pageSize)
                                    },
                                }}
                                locale={{
                                    emptyText: 
                                        <Empty 
                                            description="Список пуст"
                                        />
                                }}
                                dataSource={
                                    [
                                        {
                                            title: null,
                                            text: 'Ешьте маленькими порциями. Вместо того, чтобы есть два-три больших приема пищи в день, попробуйте есть пять-шесть маленьких порций в течение дня. Это поможет вашему организму лучше переваривать пищу и даст вам чувство сытости на дольшее время'
                                        },{
                                            title: null,
                                            text: 'Уменьшите потребление быстрых углеводов. Быстрые углеводы, такие как сахар, могут быстро повысить уровень сахара в крови, но затем быстро опустить его, что может вызвать чувство голода и желание переедать. Замените быстрые углеводы на более медленно усваивающиеся углеводы, такие как овощи, фрукты, цельные зерна и бобовые'
                                        },{
                                            title: null,
                                            text: 'Избегайте еды перед сном. Постарайтесь завершить употребление пищи за пару часов до сна, чтобы ваш организм успел переварить еду и вы могли спокойно заснуть'
                                        },{
                                            title: null,
                                            text: 'Увеличьте потребление белков. Белки помогают организму чувствовать себя сытым на дольшее время, поэтому старайтесь включать их в свой рацион. Это могут быть мясо, рыба, яйца, тофу или другие источники белка'
                                        },{
                                            title: null,
                                            text: 'Пейте достаточно воды. Вода помогает поддерживать правильную работу организма, улучшает пищеварение и помогает вывести токсины из организма. Попробуйте пить по меньшей мере восемь стаканов воды в день'
                                        }
                                    ]
                                }
                                renderItem={(item, index) => (
                                    <List.Item key={index} data-index={`${(page2 - 1) * paginationSize + index + 1}`} >
                                        <none />
                                        {item.title ? 
                                            <p className='title'>{item.title}</p>
                                        :
                                            null
                                        }
                                        <p className='text'>{item.text}</p>
                                    </List.Item>
                                )}
                            />
                        </div>
                        <div className='text_content'>
                            <p>Избегание переедания и закусок перед сном — это важная часть здорового образа жизни. Следуя простым советам по правильному питанию, вы можете улучшить своё самочувствие и предотвратить множество заболеваний. Помните, что еда — это ваше топливо, поэтому выбирайте правильное топливо для вашего организма и он будет работать наилучшим образом</p>
                        </div>
                        <div className="fcenter">
                            <a href={`${FILES}/pdf/snack.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                        </div>
                    </Modal>
                    <section className='container_full --hls_item_5'>
                        <section className='top'>
                            <section className='container shadow default_padding'>
                                <h1>Избегайте переедания и закусок перед сном</h1>
                            </section>
                        </section>
                        <section className='body'>
                            <section className='container shadow default_padding'>
                                <section className='left'>
                                    <p className='title'>Рекомендуем ознакомиться</p>
                                    <p className='excerpt'>Прочитав статьи вы сможете качественно улучшить текущее состояние вашего здоровья.</p>
                                    <div className='slider_pc'>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_00.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Здоровый образ жизни</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_01.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Правильное питание</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_02.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Физическая активность</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                        <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                            <div className='article_background'>
                                                <img src={`${IMAGES}/banners/hls_image_03.jpeg`} />
                                            </div>
                                            <div className='article_column'>
                                                <div className='article_column_left'>
                                                    <div className='article_title'>Здоровый сон</div>
                                                </div>
                                                <div className='article_column_right'>
                                                    <span></span>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className='slider_mob'>
                                        <Swiper
                                            loop
                                            spaceBetween={12}
                                            slidesPerView={1.5}
                                            pagination={{
                                                type: "progressbar",
                                            }}
                                            navigation={{
                                                prevEl: navigationPrevRef.current,
                                                nextEl: navigationNextRef.current,
                                            }}
                                            onBeforeInit={(swiper) => {
                                                swiper.params.navigation.prevEl = navigationPrevRef.current;
                                                swiper.params.navigation.nextEl = navigationNextRef.current;
                                            }}
                                            breakpoints={{
                                                992: {
                                                    slidesPerView: 2.75,
                                                },
                                                991: {
                                                    slidesPerView: 2,
                                                },
                                                700: {
                                                    slidesPerView: 1.5,
                                                },
                                            }}
                                        >
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_00.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Здоровый образ жизни</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_01.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Правильное питание</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_02.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Физическая активность</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                            <SwiperSlide>
                                                <Link to={`/hls/`} exact={ true } onClick={() => scroll.scrollToTop()} className='article'>
                                                    <div className='article_background'>
                                                        <img src={`${IMAGES}/banners/hls_image_03.jpeg`} />
                                                    </div>
                                                    <div className='article_column'>
                                                        <div className='article_column_left'>
                                                            <div className='article_title'>Здоровый сон</div>
                                                        </div>
                                                        <div className='article_column_right'>
                                                            <span></span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </SwiperSlide>
                                        </Swiper>
                                    </div>
                                </section>
                                <section className='right'>
                                    <div className='content'>
                                        <div className='header'>
                                            <div className='posts_image_big'>
                                                <img src={`${IMAGES}/banners/hls_image_01_05_01.jpeg`} />
                                            </div>
                                        </div>

                                        <div className='body'>
                                            <div className='text_content'>
                                                <p>Переедание может привести к перегрузке вашего желудка и снизить вашу энергию и продуктивность. Кроме того, закуски перед сном могут затруднить сон. Попробуйте есть маленькими порциями и заканчивать употребление пищи за пару часов до сна.</p>
                                                <p>Еда является одним из самых важных компонентов для нашего здоровья. Она не только даёт нам энергию для выполнения повседневных задач, но и поддерживает наш организм в хорошей форме. Однако, не все знают, что переедание и закуски перед сном могут негативно влиять на здоровье. В этой статье мы рассмотрим, почему избегать переедания и закусок перед сном важно для нашего здоровья, и как правильно питаться, чтобы улучшить свое самочувствие.</p>
                                                <div className='list_item'>
                                                    <div className='visible'>
                                                        <img className='banner' src={`${IMAGES}/banners/hls_image_01_05_02.jpeg`} />
                                                        <div className='right_info'>
                                                            <div className='info'>
                                                                <div className='title'>Узнай свой индекс массы тела</div>
                                                                <div className='description'>Онлайн калькулятор индекса массы тела помогает оценить соотношение вашего веса и роста</div>
                                                            </div>
                                                            <Link to={`/calculators/1`} exact={ true } onClick={() => scroll.scrollToTop()} className={`ant-btn ant-btn-primary default button_more`}><span>Рассчитать</span></Link>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p>Вода является одним из самых важных компонентов для здоровья нашего организма. Наше тело состоит примерно из 60% воды, и ежедневное употребление воды является необходимым условием для правильной работы органов и систем. Несмотря на это, большинство людей не употребляют достаточное количество воды в свой рацион. В этой статье мы рассмотрим, почему вода важна для вашего здоровья и как правильно употреблять ее.</p>
                                                <h3>Переедание: почему это плохо</h3>
                                                <p>Переедание - это когда мы употребляем больше пищи, чем наш организм может переварить и усвоить за короткий промежуток времени. Как результат, наш желудок перегружается  и мы чувствуем тяжесть, усталость и дискомфорт. Кроме того, переедание может привести к набору лишних килограммов, что может повысить риск различных заболеваний, таких как диабет и сердечно-сосудистые заболевания.</p>
                                                <h3>Закуски перед сном: почему это плохо</h3>
                                                <p>Закуски перед сном - это еще одна плохая привычка, которая может негативно влиять на наше здоровье. Когда мы едим перед сном, наш желудок должен продолжать работать на ночь, что может затруднить процесс засыпания. Кроме того, если мы едим не здоровую еду, например, жирную или сладкую, это может привести к набору веса, проблемам с пищеварением и другим заболеваниям.</p>
                                            </div>
                                            <section className='container shadow default_padding next'>
                                                <div className='next_container' onClick={() => setActiveModal('snack')}>
                                                    <div className='content full'>
                                                        <div className='list visible'>
                                                            <div className='item image_item'>
                                                                <div className='rotate' style={{background: `url(${IMAGES}/banners/hls_image_01_05_03.jpeg)`}}>

                                                                </div>
                                                            </div>
                                                            <div className='item text_item'>
                                                                <div className='rotate'>
                                                                    <p>Как правильно питаться</p>
                                                                    <span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </section>
                            </section>
                        </section>
                    </section>
                </>
            }
        </>
    );
};